"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const useDeepMemo_1 = require("../../hooks/useDeepMemo");
const theme_1 = require("../../theme");
const common_styled_components_1 = require("../common-styled-components");
const CompareBarChart_1 = __importStar(require("../custom/CompareBarChart"));
const PrivateContentVeil_1 = require("../generic/PrivateContentVeil");
const TimelineChart_1 = __importDefault(require("../custom/TimelineChart"));
const calculatorUtils_1 = require("../../util/calculatorUtils");
const constants_1 = require("../constants");
const lodash_1 = require("lodash");
exports.default = ({ params, fuelTypes, calculation, metadata, texts, }) => {
    const resultDetails = (0, useDeepMemo_1.useDeepMemo)(() => (0, calculatorUtils_1.calculateSurplusResults)(calculation), [calculation, params, fuelTypes]);
    const { originalFuel, cumulativeCosts, cumulativeEmissions, originalPathTimeline, lastAccumulationYear, } = resultDetails;
    const cost_per_exceeded_emission_ton = {
        name: "Cost per exceeded emission ton (original fuel)",
        value: calculation.original_fuel.timeline
            .find((d) => d.year === 2025)
            ?.cost_per_exceeded_emission_ton.find((d) => d.with_emissions === false)
            ?.value ?? 0,
        color: (0, CompareBarChart_1.getComparisonColor)(0),
    };
    return ((0, jsx_runtime_1.jsx)("div", { children: calculation && resultDetails && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.UISection, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { children: "Overview" }), (0, jsx_runtime_1.jsx)(TimelineChart_1.default, { title: "Yearly carbon surplus", 
                            // subTitle="The regulated carbon intensity target timeline, along with your energy sources' carbon intensities." // {texts.carbon_intensity_targets}
                            unit: "tCO\u2082e", forceDigits: 1, data: [
                                {
                                    name: `Surplus`,
                                    color: theme_1.theme.colors.blue,
                                    values: calculation.co2_surplus,
                                    hideCircles: true,
                                },
                                // {
                                //   name: texts.target_for_each_year,
                                //   color: theme.colors.blue,
                                //   values: Object.keys(metadata.intensity).map((year) => ({
                                //     year: Number(year),
                                //     value: metadata.intensity[year],
                                //   })),
                                // },
                            ], chartType: "stepAfter" }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Grid, { maxCellWidth: constants_1.MAX_SMALL_CELL_WIDTH, children: [originalFuel?.fuel_cost_per_ton !== undefined &&
                                    (0, lodash_1.every)(params.comparison_fuels, (f) => f.fuel_price !== undefined) && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(CompareBarChart_1.default, { unit: "USD/t", valueSeries: [
                                            {
                                                title: "Fuel price",
                                                selectorLabel: "Fuel price",
                                                values: [
                                                    {
                                                        name: originalFuel.fuel_name,
                                                        color: (0, CompareBarChart_1.getComparisonColor)(0),
                                                        value: originalFuel.fuel_cost_per_ton,
                                                    },
                                                ],
                                            },
                                        ] }) })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(CompareBarChart_1.default, { unit: "MJ/g", maxDigits: 3, valueSeries: [
                                            {
                                                title: "LCV",
                                                selectorLabel: "LCV",
                                                values: [
                                                    {
                                                        name: originalFuel.fuel_name,
                                                        color: (0, CompareBarChart_1.getComparisonColor)(0),
                                                        value: originalFuel.energy_content,
                                                    },
                                                ],
                                            },
                                        ] }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(CompareBarChart_1.default, { unit: "USD/GJ", valueSeries: [
                                            {
                                                title: "Energy cost",
                                                selectorLabel: "Energy cost",
                                                values: [
                                                    {
                                                        name: originalFuel.fuel_name,
                                                        color: (0, CompareBarChart_1.getComparisonColor)(0),
                                                        value: (0, calculatorUtils_1.getPricePerGJ)(originalFuel.fuel_cost_per_ton, originalFuel.energy_content),
                                                    },
                                                ],
                                            },
                                        ] }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(CompareBarChart_1.default, { unit: "gCO2e/MJ", valueSeries: [
                                            {
                                                title: "Carbon intensity",
                                                selectorLabel: "Carbon intensity",
                                                values: [
                                                    {
                                                        name: originalFuel.fuel_name,
                                                        color: (0, CompareBarChart_1.getComparisonColor)(0),
                                                        value: calculation.carbon_intensity,
                                                    },
                                                ],
                                            },
                                        ] }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(CompareBarChart_1.default, { unit: "% of 2025 target", valueSeries: [
                                            {
                                                title: "Carbon intensity",
                                                selectorLabel: "Carbon intensity",
                                                values: [
                                                    {
                                                        name: originalFuel.fuel_name,
                                                        color: (0, CompareBarChart_1.getComparisonColor)(0),
                                                        value: (originalFuel.intensity /
                                                            metadata.intensity[2025]) *
                                                            100,
                                                    },
                                                ],
                                            },
                                        ] }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(CompareBarChart_1.default, { unit: "$/t", 
                                        // details="The original fuel value is the cost per exceeded emission ton,
                                        // ie. the excess cost of using the current fuel."
                                        details: "Cost of staying compliant in FuelEU Maritime regulation.\n                  For the fossil fuel, this is the penalty cost, and for the alternatives, this\n                  is the energy cost premium.", valueSeries: [
                                            {
                                                title: "Cost per reduced CO₂e ton 2025",
                                                selectorLabel: "Fuel cost",
                                                values: [cost_per_exceeded_emission_ton],
                                            },
                                            {
                                                title: "Cost per reduced CO₂e ton 2025, incl. EU ETS costs",
                                                selectorLabel: "incl. EU ETS costs",
                                                values: [cost_per_exceeded_emission_ton],
                                            },
                                        ], hideDifference: true }) })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.Legend, { children: (0, jsx_runtime_1.jsx)(common_styled_components_1.LegendItem, { color: theme_1.theme.colors.grey(2), text: originalFuel.fuel_name }) })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.UISection, { children: [(0, jsx_runtime_1.jsx)(TimelineChart_1.default, { title: "Fuel EU Maritime carbon intensity targets", subTitle: "The regulated carbon intensity target timeline, along with your energy sources' carbon intensities." // {texts.carbon_intensity_targets}
                            , unit: "gCO\u2082e/MJ", forceZero: true, forceDigits: 1, data: [
                                {
                                    name: `${originalFuel.fuel_name} intensity`,
                                    color: theme_1.theme.colors.grey(2),
                                    values: Object.keys(metadata.intensity).map((year) => ({
                                        year: Number(year),
                                        value: calculation.carbon_intensity,
                                    })),
                                    hideCircles: true,
                                },
                                {
                                    name: texts.target_for_each_year,
                                    color: theme_1.theme.colors.blue,
                                    values: Object.keys(metadata.intensity).map((year) => ({
                                        year: Number(year),
                                        value: metadata.intensity[year],
                                    })),
                                },
                            ], chartType: "stepAfter" }), (0, jsx_runtime_1.jsx)(TimelineChart_1.default, { title: texts.penalty_title ||
                                "Yearly emission penalties with current energy source", subTitle: `Yearly penalties just using ${originalFuel.fuel_name}, converted to $`, unit: "$", data: [
                                {
                                    name: originalFuel.fuel_name,
                                    color: theme_1.theme.colors.grey(2),
                                    values: calculation.penalty,
                                },
                            ], canDivide: true, forceZero: true, chartType: "stepAfter" })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.UISection, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { children: "Original path" }), (0, jsx_runtime_1.jsx)(PrivateContentVeil_1.PrivateContentVeil, { title: `Total CO₂e emissions and total costs 2025-${lastAccumulationYear}`, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.Grid, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(CompareBarChart_1.default, { unit: texts.weight_unit, valueSeries: [
                                                {
                                                    title: `Total CO₂e emissions 2025-${lastAccumulationYear}`,
                                                    selectorLabel: `Total CO₂e emissions 2025-${lastAccumulationYear}`,
                                                    values: [
                                                        {
                                                            name: "Original",
                                                            value: cumulativeEmissions.original,
                                                            color: (0, CompareBarChart_1.getComparisonColor)(0),
                                                        },
                                                    ],
                                                },
                                            ] }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(CompareBarChart_1.default, { unit: "M$", valueSeries: [
                                                {
                                                    title: `Total cost 2025-${lastAccumulationYear}`,
                                                    selectorLabel: `Total cost 2025-${lastAccumulationYear}`,
                                                    values: [
                                                        {
                                                            name: "Original",
                                                            value: cumulativeCosts.original / 1000000,
                                                            color: (0, CompareBarChart_1.getComparisonColor)(0),
                                                        },
                                                    ],
                                                },
                                            ] }) })] }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.Legend, { children: (0, jsx_runtime_1.jsx)(common_styled_components_1.LegendItem, { color: theme_1.theme.colors.grey(2), text: originalFuel.fuel_name }) }), (0, jsx_runtime_1.jsx)(PrivateContentVeil_1.PrivateContentVeil, { title: "Yearly cost analysis", children: (0, jsx_runtime_1.jsx)(TimelineChart_1.default, { title: "Yearly cost analysis", unit: "$", canDivide: true, forceZero: true, errorYearMessage: texts.no_compliance, 
                                // complianceData={complianceData.combined}
                                data: [
                                    {
                                        name: `Cost of plan with ${originalFuel.fuel_name}`,
                                        color: theme_1.theme.colors.grey(2),
                                        values: originalPathTimeline,
                                    },
                                ], chartType: "stepAfter" }) }), (0, jsx_runtime_1.jsx)(PrivateContentVeil_1.PrivateContentVeil, { title: `Cost breakdown of original path (${originalFuel.fuel_name})`, children: (0, jsx_runtime_1.jsx)(TimelineChart_1.default, { subTitle: `Cost breakdown of original path (${originalFuel.fuel_name})`, unit: "$", canDivide: true, forceZero: true, 
                                // forcedMaxValue={maxCost} don't force same scale as below
                                errorYearMessage: texts.no_compliance, data: [
                                    {
                                        name: `Fuel cost`,
                                        color: theme_1.theme.colors.grey(2),
                                        values: originalPathTimeline.map((v) => ({
                                            year: v.year,
                                            value: v.fuel_cost,
                                        })),
                                    },
                                    {
                                        name: `Emission cost`,
                                        color: theme_1.theme.colors.grey(1),
                                        values: originalPathTimeline.map((v) => ({
                                            year: v.year,
                                            value: v.emission_cost,
                                        })),
                                    },
                                    {
                                        name: `Penalties`,
                                        color: theme_1.theme.colors.grey(0),
                                        values: originalPathTimeline.map((v) => ({
                                            year: v.year,
                                            value: v.penalty,
                                        })),
                                    },
                                ], chartType: "bar" }) })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.UISection, {})] })) }));
};
